<template>
  <textarea
    :name="name"
    :value="value"
    :placeholder="placeholder"
    :rows="rows"
    :cols="cols"
    :disabled="disabled"
    @input="updateValue"
    :class="{'is-error': error}"
    class="form-textfield"
  ></textarea>
</template>

<script>

export default {
  name: "form-textarea",
  props: {
    value: { type: String, require: true },
    name: { type: String, require: true },
    placeholder: { type: String, require: false },
    rows: { type: Number, require: false },
    cols: { type: Number, require: false },
    disabled: { type: Boolean, require: false, 'default':false },
    error: { type: Boolean, require: false, 'default':false }
  },
  methods: {
    updateValue: function(e) {
      this.$emit("input", e.target.value);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.form-textfield {
  width: 100%;
  max-width: 600px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid $border;
  height: 100px;
  padding: 10px;
  font-size: 14px;
  line-height: 1.4;
  &:disabled {
		background-color: #eee;
		color: #777;
  }
  &.is-error {
    background-color: $error-bg;
  }
}
</style>
  